import moment from 'moment'

const companyFactory = {
  toAPI: data =>
    data && {
      nomeFantasia: data.name,
      cnaePrincipal: data.cnae,
      faturamentoMedioMensal: String(data.income)
        .replace('.', '')
        .replace(',', ''),
      pap: data.pap,
      documento: data.cnpj
    },
  toForm: data =>
    data && {
      name: data.nomeFantasia,
      cnpj: data.cnpj,
      companyName: data.razaoSocial,
      doc: moment(data.dataConstituicao).format('DD/MM/YYYY'),
      foc: data.formaConstituicao,
      cnae: data.cnaePrincipal,
      registration: data.inscricaoMunicipal,
      income: data.faturamentoMedioMensal,
      avatar: data.avatar,
      pap: data.pap
    }
}

export default companyFactory



// WEBPACK FOOTER //
// ./src/app/pages/EditCompanyData/factory.js